import { render, staticRenderFns } from "./balance_detail.vue?vue&type=template&id=144c341f&scoped=true"
import script from "./balance_detail.vue?vue&type=script&lang=js"
export * from "./balance_detail.vue?vue&type=script&lang=js"
import style0 from "./balance_detail.vue?vue&type=style&index=0&id=144c341f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c341f",
  null
  
)

export default component.exports